import Marquee from "react-fast-marquee";
import { IAS_PEDAGOGY } from "../../app-constants";

const MovingBanner = () => {
  return (
    <div
      style={{
        backgroundColor: "#00306e",
        //backgroundColor: "#d2093c",
        paddingTop: "2px",
        color: "white",
        height: "32px",
      }}
    >
      <Marquee speed={60} gradient={false}>
        IAS Jnani – Your Path to UPSC Success &nbsp;&nbsp;|&nbsp;&nbsp;
        Admissions Open for&nbsp;&nbsp;
        <b>March 2026 Batch</b> &nbsp;&nbsp;|&nbsp;&nbsp; ₹75,000
        &nbsp;&nbsp;|&nbsp;&nbsp; 7-Month Intensive Program
        &nbsp;&nbsp;|&nbsp;&nbsp; Limited to 70 Students Only
        &nbsp;&nbsp;|&nbsp;&nbsp; Learn from Expert Faculty
        &nbsp;&nbsp;|&nbsp;&nbsp; Prelims&nbsp; Analytical&nbsp; Elimination
        Method &nbsp;&nbsp;|&nbsp;&nbsp; Mental&nbsp; Answer&nbsp; Writing
        Practice &nbsp;&nbsp;|&nbsp;&nbsp; Rigorous Mock Tests
        &nbsp;&nbsp;|&nbsp;&nbsp; Personalized Mentorship
        &nbsp;&nbsp;|&nbsp;&nbsp; <b>Enroll Now – Few Seats Remaining!</b>{" "}
        &nbsp;&nbsp;|&nbsp;&nbsp; Call or WhatsApp:&nbsp;&nbsp;
        <a
          href={`tel:${IAS_PEDAGOGY.OFFICE_PHONE}`}
          style={{
            color: "yellow",
            textDecoration: "none",
            fontWeight: "bold",
          }}
        >
          {IAS_PEDAGOGY.OFFICE_PHONE}
        </a>{" "}
        &nbsp;&nbsp; | &nbsp;&nbsp;
        <a
          href={`tel:${IAS_PEDAGOGY.PHONE_CONTACT2}`}
          style={{
            color: "yellow",
            textDecoration: "none",
            fontWeight: "bold",
          }}
        >
          {IAS_PEDAGOGY.PHONE_CONTACT2}
        </a>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </Marquee>
    </div>
  );
};

export default MovingBanner;
